export default __webpack_public_path__ + "static/media/a1.820b4d5d.png";